import { Container, Row, Col } from "react-bootstrap";

import logo from "../assets/img/Ashu_logo.png";
import { FiGithub } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";
import { SlSocialLinkedin } from "react-icons/sl";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" className="logName" />
            <span className="nameText logName">shutosh Kumar</span>
            <span className="visibleName">Ashutosh Kumar</span>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/ashutoshkr01/"
                rel="noreferrer"
                target="_blank"
              >
                <SlSocialLinkedin className="sIcon" />
              </a>
              <a
                href="https://github.com/ashutoshgithubs"
                rel="noreferrer"
                target="_blank"
              >
                <FiGithub
                  style={{
                    color: "white",
                  }}
                  className="sIcon"
                />
              </a>
              <a
                href="https://twitter.com/Ashubhai_01?t=zw2Tp2VixttRWhjogO0weA&s=09"
                rel="noreferrer"
                target="_blank"
              >
                <FaXTwitter
                  style={{
                    color: "white",
                  }}
                  className="sIcon"
                />
              </a>
            </div>
            <p>Copyright 2024. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
